import * as ChangeLanguageActions from 'actions/changeLanguage';

export default function localeReducer(languageId, action) {
    switch (action.type) {
        case ChangeLanguageActions.CHANGE_LANGUAGE:
            if(window.SIR){
                window.SIR('changeLanguage', action.languageId === 1 ? 'ru' : 'en')
            }
            localStorage.setItem('languageId', action.languageId);
            return action.languageId;
    }

    return languageId;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/localeReducer.js